import { Koi } from '@ksyos/koi';
import { ExportStatusFilter, PayoutType } from '@common/enums';

export const paymentsSearchFilterValidation = {
    activityType: Koi.koi().enum(PayoutType),
    endDate: Koi.when('startDate', {
        is: Koi.exist(),
        otherwise: Koi.koi().date(),
        then: Koi.koi().date().endDate(),
    }).allow(null),
    episodeCategoryId: Koi.string().uuid(),
    exportStatus: Koi.koi().enum(ExportStatusFilter),
    groupId: Koi.string().uuid(),
    noPayoutReason: Koi.string(),
    payoutsOnly: Koi.boolean(),
    performerOrganizationId: Koi.string().uuid(),
    performerPractitionerId: Koi.string().uuid(),
    searchField: Koi.string().valid('processId', 'txcsProcesId', 'practitionerId', 'organizationId', 'relationNumber'),
    searchText: Koi.string().max(255).allow(''),
    serviceId: Koi.string().uuid(),
    startDate: Koi.koi().date().allow(null),
};

export const paymentsSearchFilterValidationSchema = {
    schema: Koi.object(paymentsSearchFilterValidation).options({ convert: false, presence: 'optional' }),
};
